<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [hideHeader]="true"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   [pluralNameOverride]="'Faxes'"
>
   <ndt-register-quick-filter>
      <mat-form-field>
         <mat-label>Filter by status</mat-label>
         <input
            [lcsSingleSelect]="faxStatusSelect"
            ndtFaxStatusSelect
            autocomplete="off"
            type="text"
            [ngModel]="selectedFaxStatus"
            (ngModelChange)="onFaxStatusSelected($event)"
            id="fax-status"
         />
         <ndt-fax-status-select #faxStatusSelect isIncludeEmptyOption="true"></ndt-fax-status-select>
      </mat-form-field>
      <ndt-call-history-filter
         [isFaxRegister]="true"
         (logQuickFilterChanged)="onFilterChange($event)"
      ></ndt-call-history-filter>
   </ndt-register-quick-filter>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="createDate" width="2.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="createDate-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Desc"
               sortField="createDate"
               >Date/Time<mat-icon class="mat-icon-sort">{{ getSort('createDate') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let faxes">
               <a (click)="onOpenDialog(faxes)">{{ faxes.createDate | date : 'MM/dd/yyyy hh:mm:ss aa' }}</a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="faxType" width="2.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="faxType-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="faxTypeId"
               >In/Out<mat-icon class="mat-icon-sort">{{ getSort('faxTypeId') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let faxes">
               <a (click)="onOpenDialog(faxes)">{{ faxes.faxType }}</a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="faxSource" width="3">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="faxSource-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="from"
               >From<mat-icon class="mat-icon-sort">{{ getSort('from') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let faxes">
               <a (click)="onOpenDialog(faxes)">{{ faxes.faxSource | formatPhoneNumbers }}</a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="faxDestination" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="faxDestination-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="to"
               >To<mat-icon class="mat-icon-sort">{{ getSort('to') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let faxes">
               <a (click)="onOpenDialog(faxes)">{{ faxes.faxDestination | formatPhoneNumbers }}</a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="faxStatus" width="1.5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="faxStatus-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="faxStatusName"
               >Status<mat-icon class="mat-icon-sort">{{ getSort('faxStatusName') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let faxes">
               <a (click)="onOpenDialog(faxes)">{{ faxes.faxStatus | addSpaces }}</a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="detail" width="0.75">
            <th lcs-header-cell *lcsHeaderCellDef id="duration-column-header"></th>
            <td lcs-cell *lcsCellDef="let faxes">
               @if (faxes) {
               <button
                  type="button"
                  mat-button
                  matTooltip="Info"
                  aria-label="Details Info"
                  id="extension-detail-info"
                  [matMenuTriggerFor]="faxMenu"
                  ><mat-icon> more_horiz </mat-icon>
               </button>
               }
               <mat-menu #faxMenu="matMenu">
                  <button mat-menu-item type="button" id="active-call-details" (click)="onOpenDialog(faxes)">
                     Details
                  </button>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
